import { Typography } from 'antd'
import React, { ComponentProps } from 'react'
import { DesignSystem } from '~/core/designSystem'

type Props = ComponentProps<typeof Typography.Title>

export const TitlePrimary: React.FC<Props> = ({ children, ...props }) => {
  return (
    <Typography.Title
      {...props}
      level={3}
      style={{
        paddingLeft: '8px',
        marginBottom: '16px',
        borderLeft: `4px solid ${DesignSystem.ThemeConst.PRIMARY_YELLOW}`,
        ...props.style,
      }}
    >
      {children}
    </Typography.Title>
  )
}
